<!-- <div class="w-full">
<h3 class="text-lg">{{ lastSearchesText }}</h3>

<ng-container
    *ngIf="
      !!favoriteStations?.lastSearches &&
        !!favoriteStations?.lastSearches.length;
      then lastSearches;
      else emptySearches
    "
  />
  <ng-template #lastSearches>
    <ul class="flex flex-col list-none p-0 gap-2">
      <ng-container *ngFor="let stationData of favoriteStations.lastSearches">
        <li
          class="cursor-pointer"
          (click)="onFavoriteStationClick.emit(stationData)"
          >
          <app-favorite-station [station]="stationData" />
        </li>

        <mat-divider class="bg-gray-600" />
      </ng-container>
    </ul>
  </ng-template>

  <ng-template #emptySearches>
    <img src="/assets/images/route-planning/search-line/last_lines_empty.svg" [attr.alt]="altEmptyLines" />
  </ng-template>
</div> -->

<div class="px-4">
  <div class="flex justify-between items-center">
    <h3 class="text-lg">{{ favoriteStationText }}</h3>
    <mot-button
      (onClick)="openEditFavoritesMenu()"
      textClass="text-base"
      buttonClass="!bg-transparent"
      [text]="editText"
      ariaHaspopup="dialog"
      />
    </div>

    @if (
      !!favoriteStations?.stations && !!favoriteStations?.stations.length) {
      <ul class="flex flex-col list-none p-0 pb-32 gap-2">
        @for (stationData of favoriteStations?.stations; track stationData) {
          <li
            class="cursor-pointer"
            (click)="onFavoriteStationClick.emit(stationData)"
            >
            <app-favorite-station [station]="stationData" />
          </li>
          <mat-divider class="bg-gray-600" />
        }
      </ul>
    } @else {
      <!-- Decorative empty state — SR uses the header "עריכה" button instead. -->
      <div class="flex gap-2 items-center" [class]="direction" aria-hidden="true">
        <img
          src="assets/images/route-planning/search-stations/station_empty_state.svg"
          alt=""
          />
        <div class="flex flex-col gap-[0.125rem]">
          <span class="text-[#3D5979] font-normal text-sm">{{ didntAddFavoriteStationsTextPart1 }}</span>
          <span class="text-[#3D5979] font-normal text-sm">{{ didntAddFavoriteStationsTextPart2 }}</span>
        </div>
      </div>
    }


    </div>
